import React from "react";
import styles from "./modal.module.css";

export const AlreadyExistModal = ({ error }) => {
  return (
    <div
      className={`modal show fade modal-dialog-centered ${
        error ? styles.disBlock : styles.disNone
      }`}
      id="staticBackdrop"
      tabIndex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-body d-flex align-items-center justify-content-center flex-row py-4">
            <span className="fs-5 text-danger">Already exists in Wallet</span>
            <div style={{ fontSize: "1rem" }} className="ms-3">❌</div>
          </div>
        </div>
      </div>
    </div>
  );
};
